import * as dot from "dot-wild";
import { DespatchCrew } from "Models/despatch.crew";
import { DespatchTask, TaskStorageBox, TeamFleet, TeamMember } from "Models/despatch.task";

import { simpleStringMatcher } from "./stringMatcher";

const searchFields: Record<"task" | "crew", Record<string, string>> = {
  task: {
    leader: "team.memberLeader.fullName",
    members: "fullName",
    orderReference: "job.reference",
    equipment: "fleetNumber",
    storageBoxes: "number",
  },
  crew: {
    leader: "memberLeader.fullName",
    members: "fullName",
    orderReference: "job.reference",
    equipment: "fleetNumber",
    storageBoxes: "number",
  },
};

export const matchString = (options: {
  data: DespatchTask | DespatchCrew | TeamMember | TeamFleet | TaskStorageBox;
  key: string;
  value: any;
  entity: "task" | "crew";
}) => {
  const { data, key, value, entity } = options;

  const fieldToCheck = searchFields[entity][key]!;
  const currentValue = dot.get(data, fieldToCheck);

  if (!value) return true;

  return simpleStringMatcher(currentValue, value);
};
